import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import './Dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();
  const [applications, setApplications] = useState([]);
  const [workStatus, setWorkStatus] = useState(user?.workStatus || 'working');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    trackVisit();
  }, []);

  const loadData = async () => {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const res = await axios.get('/api/cms/applications?limit=10&mine=true', { headers });
      setApplications(res.data.applications || []);
    } catch (err) {
      console.error('Ошибка загрузки данных:', err);
    }
  };

  const trackVisit = async () => {
    try {
      await axios.post('/api/cms/track', {}, { withCredentials: true });
    } catch (err) { /* не критично */ }
  };

  const toggleWorkStatus = async () => {
    const newStatus = workStatus === 'working' ? 'dayoff' : 'working';
    try {
      const token = localStorage.getItem('token');
      await axios.put(`/api/cms/users/${user?.id}`, { workStatus: newStatus }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setWorkStatus(newStatus);
      setMsg(newStatus === 'working' ? '✅ Статус: Работает' : '🔴 Статус: Выходной');
      setTimeout(() => setMsg(''), 3000);
    } catch (err) {
      setMsg('Ошибка обновления статуса');
    }
  };

  const statusLabels = { new: 'Новая', in_progress: 'В работе', completed: 'Завершена', cancelled: 'Отменена' };

  return (
    <div className="dashboard">
      <div className="container">
        <div className="dashboard-header fade-in">
          <div>
            <h1>Добро пожаловать, {user?.name}!</h1>
            {msg && <div className="dashboard-msg">{msg}</div>}
          </div>
          <div className="dashboard-header-actions">
            {(user?.role === 'admin' || user?.role === 'superadmin') && (
              <div className="work-status-toggle">
                <span className={`work-badge ${workStatus}`}>
                  {workStatus === 'working' ? '🟢 Работает' : '🔴 Выходной'}
                </span>
                <button className={`toggle-btn ${workStatus}`} onClick={toggleWorkStatus}>
                  {workStatus === 'working' ? 'В выходной' : 'На работу'}
                </button>
              </div>
            )}
            <Link to="/my-applications" className="btn btn-secondary">📋 Мои заявки</Link>
            {(user?.role === 'superadmin') && (
              <Link to="/admin" className="btn btn-primary">⚙️ Панель Суперадминистратора</Link>
            )}
          </div>
        </div>

        <div className="dashboard-section fade-in">
          <h2>📋 Мои заявки</h2>
          {applications.length === 0 ? (
            <p style={{ color: '#64748b', textAlign: 'center', padding: '40px 0' }}>
              У вас пока нет заявок. <Link to="/contact">Оставьте заявку</Link>
            </p>
          ) : (
            <div className="applications-grid">
              {applications.map(app => (
                <div key={app._id} className="app-card">
                  <div className="app-header">
                    <span className={`status-badge status-${app.status}`}>
                      {statusLabels[app.status] || app.status}
                    </span>
                    <span className="app-date">
                      {new Date(app.createdAt).toLocaleDateString('ru-RU', {
                        day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit'
                      })}
                    </span>
                  </div>
                  <h3>{app.name}</h3>
                  <p className="app-service">🔧 {app.service || 'Не указана'}</p>
                  <p className="app-contact">📞 <a href={`tel:${app.phone}`}>{app.phone}</a> | ✉️ <a href={`mailto:${app.email}`}>{app.email}</a></p>
                  {app.message && (
                    <p className="app-message">💬 {app.message}</p>
                  )}
                  {app.assignedTo && (
                    <p className="app-assignee">👨‍💼 Ответственный: {app.assignedTo.name}</p>
                  )}
                  {app.comments && app.comments.length > 0 && (
                    <div className="app-comments-preview">
                      <p className="comment-item">
                        <span className="comment-user">{app.comments[app.comments.length - 1].userName || 'Система'}</span>
                        <span className="comment-date">{new Date(app.comments[app.comments.length - 1].createdAt).toLocaleDateString('ru-RU')}</span>
                      </p>
                      <p className="comment-text">{app.comments[app.comments.length - 1].text}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
